// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 216 ? "vendors" : chunkId) + "." + {"77":"ff46f48d","170":"2f56d822","216":"99d8e2e2"}[chunkId] + ".js";
};